import { getTrailUrl } from '@alltrails/shared/utils/cardLinks';
import type Trail from '@alltrails/types/Trail';
import type TrailDetails from '@alltrails/core/types/TrailDetails';
import type { TrailId } from '@alltrails/types/TrailId';
import { LinkInfo } from '@alltrails/denali/types';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { JSX } from 'react';
import TrailAvatar from '../TrailAvatar';
import EntityLabel from '../EntityLabel';

export type Props = {
  baseUrl?: string;
  className?: string;
  languageRegionCode: LanguageRegionCode;
  onClick?: () => void;
  secondaryText?: string;
  tertiaryText?: string | { linkInfo: LinkInfo; onClick?: () => void; text: string };
  testIdPrefix?: string;
  ratingValue?: number;
  trail:
    | Trail
    | TrailDetails
    | {
        id: TrailId;
        name: string;
        slug: string;
      };
};

const TrailLabel = ({
  baseUrl,
  className,
  languageRegionCode,
  onClick,
  secondaryText,
  tertiaryText,
  testIdPrefix,
  trail,
  ratingValue
}: Props): JSX.Element => {
  const { id, name, slug } = trail;

  const href = getTrailUrl(slug, baseUrl, languageRegionCode);
  const testIdPrefixWithName = testIdPrefix ? `${testIdPrefix}-${name}` : name;

  return (
    <EntityLabel
      avatar={<TrailAvatar linkInfo={{ href, target: '_blank' }} trailId={id} trailName={name} />}
      className={className}
      link={{ href }}
      onClick={onClick}
      secondaryText={secondaryText}
      tertiaryText={tertiaryText}
      testIdPrefix={testIdPrefixWithName}
      title={name}
      ratingValue={ratingValue}
    />
  );
};

export default TrailLabel;
